import React from "react";
// route
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

// context
import GlobalContext from "./context/globalContext";

// setting
import "./utils/setting";

// desing
import "./assets/css/main.css";

// pages
import Layout from "./pages/layout";
import Dashboard from "./pages/dashboard";
import Password from "./pages/password";
import Users from "./pages/users";
import Profile from "./pages/profile";
import Persons from "./pages/persons";
import Reports from "./pages/reports";
import Login from "./pages/login";
import Task from "./pages/task";
import PrivateRoute from "./components/PrivateRoute";
import StateReport from "./pages/state-report";
import Photos from "./pages/photos";

function App(props) {
    return (
        <Router>
            <GlobalContext>
                <Switch>
                    <Route path="/login">
                        <Login />
                    </Route>
                    <PrivateRoute exact path="/">
                        <Layout>
                            <Dashboard />
                        </Layout>
                    </PrivateRoute>
                    <PrivateRoute path="/users">
                        <Layout>
                            <Users />
                        </Layout>
                    </PrivateRoute>
                    <PrivateRoute path="/persons">
                        <Layout>
                            <Persons />
                        </Layout>
                    </PrivateRoute>
                    <PrivateRoute path="/reports">
                        <Layout>
                            <Reports />
                        </Layout>
                    </PrivateRoute>
                    <PrivateRoute exact path="/state-report">
                        <Layout>
                            <StateReport />
                        </Layout>
                    </PrivateRoute>
                    <PrivateRoute path="/photos">
                        <Layout>
                            <Photos />
                        </Layout>
                    </PrivateRoute>
                    <PrivateRoute path="/profile">
                        <Layout>
                            <Profile />
                        </Layout>
                    </PrivateRoute>
                    <PrivateRoute path="/password">
                        <Layout>
                            <Password />
                        </Layout>
                    </PrivateRoute>
                    <Route path="/task">
                        <Task />
                    </Route>
                </Switch>
            </GlobalContext>
        </Router>
    );
}

export default App;
